module.exports = __webpack_public_path__ + "img/wzjs1.4a3635ab.jpg";